export function tryTranslate(t: Function, propertyTranslationKey: string, path: string) {
    const pathText = t(propertyTranslationKey + path as any);
    if (pathText !== undefined && typeof pathText === 'string' && !pathText.startsWith(propertyTranslationKey) && !pathText.startsWith('key \'' + propertyTranslationKey)) {
        return pathText;
    }
    return undefined;
}
